import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "TextLeading"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10.5 9.75H22.5V11.25H10.5V9.75ZM11.25 21H22.5V22.5H11.25V21ZM19.3875 20.25H21L17.73 12.75H16.02L12.75 20.25H14.3625L14.9625 18.75H18.7875L19.3875 20.25ZM15.5625 17.25L16.875 13.9725L18.1875 17.25H15.5625ZM19.3875 9H21L17.73 1.5H16.02L12.75 9H14.3625L14.9625 7.5H18.7875L19.3875 9ZM15.5625 6L16.875 2.7225L18.1875 6H15.5625ZM4.5 11.8725L6.435 13.8075L7.5 12.75L4.5 9.75L1.5 12.75L2.5575 13.815L4.5 11.8725ZM4.5 20.3775L2.565 18.4425L1.5 19.5L4.5 22.5L7.5 19.5L6.4425 18.435L4.5 20.3775Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/TextLeading.vue"]]);
